import gql from 'graphql-tag';

export const NUCLEUS_UPDATE_CONTROLLER_ECO_MODE = gql`
  mutation UpdateControllerEcoModeStatus(
    $playerId: UUID!
    $ports: [PortsUpdateDTO!]!
    $panels: [PanelsUpdateDTO!]!
    $spis: [SpiDTO!]!
    $isEcoMode: Boolean
    $shouldAutoUpdateEcoMode: Boolean
    $frameDelayMillionSecond: Int
    $jpegCompression: Boolean
    $transmissionMode: TransmissionModeEnum
    $resetTimeoutDurationMinutes: Float
    $screenTestPatternSpeed: Int
    $screenTestPatternWidth: Int
    $shouldAllowRegularUser: Boolean
  ) {
    updateControllerEcoMode(
      playerId: $playerId
      mutationControllerEcoModeDTO: {
        ports: $ports
        panels: $panels
        spis: $spis
        isEcoMode: $isEcoMode
        shouldAutoUpdateEcoMode: $shouldAutoUpdateEcoMode
        frameDelayMillionSecond: $frameDelayMillionSecond
        jpegCompression: $jpegCompression
        transmissionMode: $transmissionMode
        resetTimeoutDurationMinutes: $resetTimeoutDurationMinutes
        screenTestPatternSpeed: $screenTestPatternSpeed
        screenTestPatternWidth: $screenTestPatternWidth
        shouldAllowRegularUser: $shouldAllowRegularUser
      }
    ) {
      code
      success
      message
      shouldAllPanelSupportEcoMode
      shouldElectricitySupportEcoMode
      shouldAllowHighBrightnessMode
      isEcoMode
      ecoModeUpdateStatus
    }
  }
`;
